import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "src/app/services/api.service";

@Injectable()
export class UpdateAppService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }
}
